import { LicenseById } from '@/api/apis';
import { getPrimary, getPrimaryValue } from '@/explore/ffl-detail/utils.mjs';
import Licensee from '@/model/licensee.mjs';
import {
  getEzCheckErrorTransferCreation,
  getIsEZCheckForTransferCreationInProgress,
  getezCheckStatusTransferCreation
} from '@/queue/ducks/selectors';
import {
  setEZCheckForTransferCreationMessage,
  setEZCheckStatusTransferCreation
} from '@/queue/ducks/slice';
import { BUSINESS_NAME, INVALID_LICENSE_NUMBER, LICENSE_NUMBER_NOT_FOUND } from '@/utils/constants';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Spinner
} from '@chakra-ui/react';
import React, { FormEvent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

interface AddBlaclistProps {
  licensee: Licensee | undefined;
  setLicensee: (arg0: Licensee | undefined) => void;
}
function AddBlacklist({
  licensee,
  setLicensee,
}: AddBlaclistProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [licenseKey, setLicenseKey] = useState<string>('');
  const email = licensee?.contact.formattedEmails;
  const phone = licensee?.contact.formattedPhoneNumbers;
  const ezCheckErrorMessage = getEzCheckErrorTransferCreation();
  const [licenseError, setLicenseError] = useState<string | null>(null);
  const ezCheckForTransferCreationInProgress =
    getIsEZCheckForTransferCreationInProgress();
  const dispatch = useDispatch();

  function lookupLicensee() {
    LicenseById(
      licenseKey.substring(0, 3),
      licenseKey.substring(licenseKey.length - 5)
    )
      .then((data: Licensee) => {
        if (!data.id) {
          setLicensee(undefined);
        }
        setLicensee({
          id: data.id,
          name: data.name,
          isBlacklisted: data?.isBlacklisted,
          contact: {
            address: {
              street1: data.contact.address?.street1,
              city: data.contact.address?.city,
              state: data.contact.address?.state,
              zip: data.contact.address?.zip
            },
            mailAddress: {
              street: data.contact.mailAddress?.street,
              city: data.contact.mailAddress?.city,
              state: data.contact.mailAddress?.state,
              zip: data.contact.mailAddress?.zip
            },
            formattedPhoneNumbers: data?.contact?.formattedPhoneNumbers,
            formattedEmails: data?.contact?.formattedEmails
          }
        } as Licensee);
      })
      .catch((e) => {
        console.log(String(e));
        setLicensee(undefined);
        setLicenseError(LICENSE_NUMBER_NOT_FOUND);
        console.log({ ezCheckErrorMessage });
      })
      .finally(() => setIsLoading(false));
  }
  console.log({ licensee });
  useEffect(() => {
    dispatch(setEZCheckStatusTransferCreation(null));
    dispatch(setEZCheckForTransferCreationMessage(null));
  }, []);
  const handleDealerSearch = (event: FormEvent) => {
    event.preventDefault();
    const matchFFLLicense = /^(\d)-?(\d\d)(?:-?[\dxX]{3}-?[\dxX]{2}-?[\da-zA-Z]{2})?-?(\d\d\d\d\d)$/;
    if(licenseKey) {
      const isValidLicenseNumber = licenseKey.match(matchFFLLicense);
      if(!isValidLicenseNumber) {
        setLicenseError(INVALID_LICENSE_NUMBER);
        setLicensee(undefined);
      } else {
        setLicenseError(null);
        setIsLoading(true);
        lookupLicensee();
      }
    }
  };
  console.log("licenseError", licenseError)
  return (
    <>
      <Box className="transfer-form-wrapper">
        <form className="transfer-form">
          <FormControl className="transfer-form__item">
            <div className="transfer-form__search-result">
              <Input
                isDisabled={isLoading}
                type="text"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setLicenseKey(e.target.value)
                }
                placeholder="Type the  FFL License Number of a dealer"
                value={licenseKey}
              />
              <Button
                type="submit"
                isDisabled={isLoading}
                onClick={handleDealerSearch}
                className="transfer-form__search-btn"
              >
                {isLoading ? (
                  <Spinner size="sm" />
                ) : (
                  <img src="/images/ui/search-icon-blue.svg" />
                )}
              </Button>
            </div>
            <FormHelperText className="transfer-form__helper-text">
              First 3, Last 5 of the FFL license number
            </FormHelperText>
            {licenseError && (
              <Box className="ez-check-status failed">{licenseError}</Box>
            )}

            {licensee?.isBlacklisted && (
              <Box className="blacklist-check-status failed">
                <img
                  className="blacklist-status__icon failed"
                  src="/images/ui/fail.svg"
                />
                <span>This dealer is already blacklisted.</span>
              </Box>
            )}
            <Box className="ez-check-status failed">{ezCheckErrorMessage}</Box>
            {ezCheckForTransferCreationInProgress && (
              <div className="ez-check-status">
                <Spinner size="sm" color="blue" />
                EZ Check In-progress
              </div>
            )}
          </FormControl>
        </form>
        {licensee && (
          <form className="transfer-form">
            <Box className="transfer-from__grid inner-box">
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  {BUSINESS_NAME}:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info">
                    {licensee?.name ? licensee.name : '-'}
                  </Box>
                </Box>
              </FormControl>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  Business Type:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info">
                    {licensee?.businessType ? licensee.businessType : '-'}
                  </Box>
                </Box>
              </FormControl>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  Email ID:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info">
                    {email && email.length > 0 ? getPrimary(email) : '-'}
                  </Box>
                </Box>
              </FormControl>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  Phone number:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info">
                    {phone && phone.length > 0 ? getPrimaryValue(phone) : '-'}
                  </Box>
                </Box>
              </FormControl>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  Mail Address:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info address-detail">
                    {licensee?.contact.mailAddress?.street}
                    <div className="blacklist-address-detail">Mailing</div>
                  </Box>
                  <Box className="transfer-form__license-info">
                    {licensee?.contact.mailAddress?.city}
                    {licensee && ', '}
                    {licensee?.contact.mailAddress?.state}{' '}
                    {licensee?.contact.mailAddress?.zip}
                  </Box>
                </Box>
              </FormControl>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  Premise Address:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info address-detail">
                    {licensee?.contact.address?.street1}
                    <div className="blacklist-address-detail">Premise</div>
                  </Box>
                  <Box className="transfer-form__license-info">
                    {licensee?.contact.address?.street2}
                  </Box>
                  <Box className="transfer-form__license-info">
                    {licensee?.contact.address?.city}
                    {licensee && ', '}
                    {licensee?.contact.address?.state}{' '}
                    {licensee?.contact.address?.zip}
                  </Box>
                </Box>
              </FormControl>
            </Box>
          </form>
        )}
      </Box>
    </>
  );
}

export default AddBlacklist;
